<template>
  <div>
    <el-dialog
      v-if="visible"
      v-el-drag-dialog
      :visible.sync="visible"
      :title="$t('Invoice.invoice_ModifyInvoiceInformation')"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form style="flex-direction: row;" label-position="left" label-width="100px">
        <el-form-item :label="$t('Invoice.invoice_invoiceType')">
          <el-select v-model="invoice.invoiceType" no="1" style="width:175px;" @change="invoiceTypeChange">
            <el-option
              v-for="item in (isFei ? InvoiceConstant.INVOICE_TYPES_FEI : InvoiceConstant.INVOICE_TYPES)"
              :key="item.code"
              :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="(invoice.invoiceType===6 || invoice.invoiceType===7)" :label="$t('Invoice.SpecificConstraintTypes')">
          <el-select v-model="invoice.specificConstraintType" style="width:175px;">
            <el-option
              v-for="item in InvoiceConstant.SPECIFIC_CONSTRAINT_TYPES"
              :key="item.code"
              :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('Invoice.invoice_makeType')">
          <el-radio-group v-model="invoice.makeType" no="3">
            <el-radio :label="0" :disabled="(invoice.invoiceType===6 || invoice.invoiceType===7)">{{ $t('Invoice.invoice_makePaper') }}</el-radio>
            <el-radio :label="1" :disabled="invoice.invoiceType!==2 && invoice.invoiceType!==3">{{ $t('Invoice.invoice_makeElectronic') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="4" type="primary" @click="updateInvoiceTypeAndMakeType">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="5" @click="closeHandler">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import { getLoading } from '@/utils/utilBaseElement'
import { updateInvoiceTypeAndMakeType } from '@/api/clearing/invoice'

export default {
  name: 'UpdateInvoiceWindow',
  props: {
    visible: { type: Boolean, required: true },
    invoiceList: { type: Array, required: true },
    fei: { type: Boolean, required: true }
  },
  data() {
    return {
      loading: false,
      innerVisible: false,
      gridParams: {},
      gridApi: {},
      invoice: {
        invoiceType: 2,
        makeType: 0,
        specificConstraintType: ''
      }
    }
  },
  computed: {
    // 发票类型
    InvoiceConstant() {
      return InvoiceConstant
    },
    // 是否支持全电
    isFei() {
      return this.invoice.makeType === 1 && this.fei
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  methods: {
    // 选择发票类型
    invoiceTypeChange(value) {
      console.log('invoiceTypeChange:', value)
      // 非增值税发票，默认选择纸质发票
      if (!(value === 2 || value === 3)) {
        this.invoice.makeType = 0
      }
      // 电子发票（增值税专用发票） /  电子发票（普通发票） 默认电子发票
      if (value === InvoiceConstant.INVOICE_TYPE_VAT_FEI.code || value === InvoiceConstant.INVOICE_TYPE_NORMAL_FEI.code) {
        if (!this.invoice.specificConstraintType) {
          this.invoice.specificConstraintType = '00'
        }
        this.invoice.makeType = 1
      } else {
        this.invoice.specificConstraintType = ''
      }
    },
    // 更新发票类型和发票种类
    updateInvoiceTypeAndMakeType() {
      this.loading = getLoading()
      const requestBody = {
        invoiceKeyList: this.invoiceList,
        invoiceType: this.invoice.invoiceType,
        makeType: this.invoice.makeType,
        specificConstraintType: this.invoice.specificConstraintType
      }
      updateInvoiceTypeAndMakeType(requestBody).then(res => {
        if (res.data > 0) {
          this.$message.success(this.$t('Message.EditedSuccessfully'))
          this.$emit('updateSuccess', { invoiceList: this.invoiceList, invoiceType: this.invoice.invoiceType,
            makeType: this.invoice.makeType })
        }
        this.innerVisible = false
      }).finally(() => {
        this.loading.close()
      })
    },
    // 取消
    closeHandler() {
      this.innerVisible = false
    }
  }
}
</script>

<style lang="scss">
</style>
